"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _getColor = require("../../../common/getColor");
var _TextWithSyllabification = _interopRequireDefault(require("../TextWithSyllabification/TextWithSyllabification"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.textBox-container h3 {\n  margin-bottom: 0px; }\n\n.textBox-container p {\n  max-width: 700px; }\n\n.textBox-container a {\n  color: #000000;\n  font-size: 14px; }\n\n@media (max-width: 66rem) {\n  .textBox-container p {\n    max-width: 616px; } }\n\n@media (max-width: 42rem) {\n  .textBox-container p {\n    max-width: 288px; } }\n";
  const fileName = "TextBox_TextBox";
  const element = document.querySelector("style[data-sass-component='TextBox_TextBox']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const Item = _ref => {
  let {
    paragraph_type,
    title_color,
    text_box_title,
    paragraph,
    paragraph_color,
    lang,
    isLast
  } = _ref;
  if (paragraph_type === 'text_box_title') {
    return /*#__PURE__*/_react.default.createElement("h3", {
      className: "sia-text-04",
      style: {
        color: (0, _getColor.getColor)(title_color?.name)
      },
      dangerouslySetInnerHTML: {
        __html: text_box_title?.replace('<p>', '')?.replace('</p>', '')
      }
    });
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `sia-text-10 ${isLast ? '' : 'sia-padding-02-bottom'}`,
    style: {
      color: (0, _getColor.getColor)(paragraph_color?.name)
    }
  }, /*#__PURE__*/_react.default.createElement(_TextWithSyllabification.default, {
    lang: lang
  }, paragraph));
};
const TextBox = _ref2 => {
  let {
    items,
    lang
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `textBox-container sia-padding-03-bottom sia-padding-03-right`
  }, items.map((item, index) => /*#__PURE__*/_react.default.createElement(Item, _extends({
    key: index
  }, item, {
    lang: lang,
    isLast: index === items.length - 1
  }))));
};
TextBox.propTypes = {
  items: _propTypes.default.array.isRequired,
  lang: _propTypes.default.string.isRequired
};
TextBox.defaultProps = {};
var _default = exports.default = TextBox;